/*
Google Analytics 4 Utility
--------------------------
Provides helper functions for tracking page views and events
*/

// Track page views
export const pageview = (url) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("config", "G-9YZ5B0LK0E", {
      page_path: url,
    });
  }
};

// Track custom events
export const event = ({ action, category, label, value }) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
